import React from 'react';
import Header from '../../common/header/header';
import Footer from '../../common/footer/footer';
import LegalDocumentBody from '../../common/legalDocumentBody/legalDocumentBody';
import cookiesFile from '../../../files/СОГЛАШЕНИЕ_ОБ_ИСПОЛЬЗОВАНИИ_COOKIES.pdf';
import { cookiesDocumentText } from '../../../data/legal/cookiesText';
import classes from '../../common/legalPage/legalPage.module.css';

const CookiesPage = () => {
  return (
    <div className={classes.page}>
      <Header />
      <main className={classes.main}>
        <section className={classes.card}>
          <h1 className={classes.title}>Соглашение об использовании cookies</h1>
          <p className={classes.subtitle}>
            Полная версия документа размещена ниже без сокращений
          </p>

          <a
            href={cookiesFile}
            download="СОГЛАШЕНИЕ_ОБ_ИСПОЛЬЗОВАНИИ_COOKIES.pdf"
            className={classes.download}
          >
            Скачать соглашение о cookies (PDF)
          </a>

          <LegalDocumentBody text={cookiesDocumentText} />
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default CookiesPage;
